/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Midi_TitleInputs */



/**
* | output |
* | --- |
* | "MIDI Configuration" |
*
* @param {Options_Adr_Midi_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_midi_title = /** @type {((inputs?: Options_Adr_Midi_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Midi_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration MIDI")
	if (locale === "de") return /** @type {LocalizedString} */ ("MIDI-Konfiguration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione MIDI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка MIDI")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración MIDI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("MIDI 配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MIDI設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("MIDI कॉन्फ़िगरेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração MIDI")
	return /** @type {LocalizedString} */ ("MIDI Configuration")
});